import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment'
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sign-up-confirmation',
  templateUrl: './sign-up-confirmation.component.html',
  styleUrls: ['./sign-up-confirmation.component.scss']
})

export class SignUpConfirmationComponent {

  constructor(private fb: FormBuilder,  public router: Router, private route: ActivatedRoute, private http: HttpClient, private toastr: ToastrService) {

    
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];

      this.http.post<any>(`${environment.apiUrl}/signup/create/${id}`, null).subscribe(
        (response) => {
          console.log(response);
          Swal.fire({
                        title : 'Parabéns',
                        text : 'Cadastro realizado com sucesso! Comece a utilizar o RealDesk agora mesmo.',
                        icon : 'success',
                        customClass : {
                          confirmButton : 'btn btn-primary icon',
                        }
                      }).then((result) => {
                        window.location.href = 'https://'+response+'.realdesk.app';
                      })
         
        },
        (error) => {
          console.error('Error:', error);
        });
    });
  }
}
